import React, { useEffect, useRef, useState } from "react";
import "./style.scss";
import {
  getPredefineOptionsList,
  openLoader,
  closeLoader,
} from "../../../AdminDashboard/AdminMentorAction/dependencies/action";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { Modal } from "react-bootstrap";
import {
  Avatar,
  Box,
  Button,
  Checkbox,
  ClickAwayListener,
  Divider,
  InputBase,
  List,
  ListItem,
  ListItemAvatar,
  ListItemSecondaryAction,
  ListItemText,
  Paper,
  Tooltip,
  Typography,
} from "@material-ui/core";
import useStyles from "./style";
import "@fontsource/montserrat";
import { TextInput } from "../textInput";
import Fuse from 'fuse.js'
import SearchRounded from "@material-ui/icons/SearchRounded";

const CustomModal = (props) => {
  const classes = useStyles();
  const { modalOpen } = props;

  const [error, setError] = useState();
  const [groupName, setGroupName] = useState();

  useEffect(() => {
    props.setTaggingList([]);
  }, [modalOpen]);

  const checkboxRef = useRef([]);

  useEffect(() => {
    checkboxRef.current = checkboxRef.current.slice(
      0,
      props.allMentorList?.length
    );
  }, [props.myMentorships]);

  const handleSubmit = () => {};
  const handleClose = () => {
    props.setModalOpen(false);
  };

  const [searchTooltipOpen, setSearchTooltipOpen] = useState(false);
  const [searchContent, setSearchContent] = useState();
  const [searchList, setSearchList] = useState([]);

  useEffect(() => {
    if (!searchContent) {
      setSearchTooltipOpen(false);
    } else {
      setSearchTooltipOpen(true);
    }
  }, [searchContent]);

  return (
    <Modal
      size="lg"
      show={props.modalOpen}
      onHide={() => props.setModalOpen(false)}
      aria-labelledby="example-modal-sizes-title-lg"
      style={{ borderRadius: "7px" }}
    >
      <Modal.Header className="d-flex ">
        <Modal.Title className="modalHeading d-flex justify-content-center">
          SEND BROADCAST MESSAGE
        </Modal.Title>
        <div className="newuserTooltip">
          <button
            type="button"
            className="btn-close"
            aria-label="Close"
            onClick={handleClose}
          />
          <span
            className="tooltiptext  close-window"
            style={{ left: "-113px", top: "2px", width: "115px" }}
          >
            Close Window
          </span>
        </div>
      </Modal.Header>
      <Modal.Body>
        <Paper elevation={0} className={classes.listContainer}>
          <Typography className={classes.goalLabel}>
            To send a broadcast message, select from list of Mentors to whom you
            wish to send this message.
          </Typography>
          <Tooltip
            open={searchTooltipOpen}
            interactive
            classes={{
              tooltip: classes.tooltip,
              tooltipArrow: classes.tooltipArrow,
            }}
            PopperProps={{
              disablePortal: true,
            }}
            arrow
            title={
              <>
                <ClickAwayListener
                  onClickAway={() => setSearchTooltipOpen(false)}
                >
                  <Paper
                    elevation={4}
                    style={{
                      padding: "15px",
                      height: "300px",
                      width: "600px",
                      overflowY: "scroll",
                    }}
                  >
                    {searchList?.map((item) => (
                      <>
                        <ListItem alignItems="center">
                          <ListItemSecondaryAction>
                            <Checkbox
                              edge="end"
                              classes={{
                                root: classes.checkboxRoot,
                              }}
                              checked={props.taggingList?.includes(item.mentorId)}
                              onChange={(e) => {
                                
                                const index = props.myMentorships?.findIndex(
                                  (ele) => ele.id === item.id
                                );
                                if (index >= 0) {
                                  checkboxRef.current[index].click();
                                }
                                props.onBroadcastSelectionChange(
                                  item,
                                  e.target.checked
                                );
                              }}
                            />
                          </ListItemSecondaryAction>
                          <ListItemAvatar>
                            <Avatar
                              classes={{
                                img: classes.objectFit,
                              }}
                              src={item?.mentorRequest?.mentorProfilePic}
                            ></Avatar>
                          </ListItemAvatar>
                          <ListItemText
                            primary={
                              <>
                                <Typography
                                  style={{
                                    fontFamily: "Montserrat",
                                    fontSize: "16px",
                                  }}
                                >
                                  {item?.mentorRequest?.mentorName}
                                </Typography>
                              </>
                            }
                          />
                        </ListItem>
                        <Divider variant="inset" style={{ height: "2px" }} />
                      </>
                    ))}
                  </Paper>
                </ClickAwayListener>
              </>
            }
          >
            <Box style={{ position: "relative" }}>
              <SearchRounded
                style={{
                  position: "absolute",
                  left: "15px",
                  top: "50%",
                  transform: "translateY(-50%)",
                  color: "rgba(0,0,0,0.3)",
                }}
              />
              <InputBase
                fullWidth
                placeholder="Search Mentors"
                value={searchContent}
                className={classes.searchField}
                onChange={(e) => {
                  setSearchContent(e.target.value);
                  const fuse = new Fuse(props.myMentorships, {
                    keys: ["mentorRequest.mentorName"],
                    threshold: 0.1,
                  });
                  const matches = fuse.search(e.target.value);
                  const results = matches.map((item) => ({...item.item, checked: props.taggingList.includes(item.item.mentorId)}));
                  setSearchList(results);
                }}
              />
            </Box>
          </Tooltip>
          <Box
            style={{
              display: "flex",
              alignItems: "center",
              margin: "0",
            }}
          >
            <Typography className={classes.goalLabel3} style={{ flex: 1 }}>
              TOTAL MENTORS: {props.myMentorships?.length}
            </Typography>

            <Typography className={classes.goalLabel3}>Select All</Typography>
            <Checkbox
              classes={{
                root: classes.checkboxRoot,
              }}
              onChange={(e) => {
                if (e.target.checked) {
                  props.myMentorships?.forEach((item, i) => {
                    if (!checkboxRef.current[i].checked) {
                      checkboxRef.current[i].click();
                    }
                  });
                  props.setTaggingList(
                    props.myMentorships?.map((item) => item.mentorId)
                  );
                } else {
                  props.myMentorships?.forEach((item, i) => {
                    if (checkboxRef.current[i].checked) {
                      checkboxRef.current[i].click();
                    }
                  });
                  props.setTaggingList([]);
                }
              }}
            />
          </Box>
          <Typography className={classes.goalLabel3} style={{textAlign: 'right', marginRight: '20px'}} >
                Selected: {props.taggingList.length}
              </Typography>
          <Box className={classes.listOverflow}>
            <List className={classes.list}>
              {props.myMentorships?.map((datum, index) => (
                <>
                  <ListItem alignItems="center">
                    <ListItemSecondaryAction>
                      <Checkbox
                        edge="start"
                        classes={{
                          root: classes.checkboxRoot,
                        }}
                        inputRef={(el) => (checkboxRef.current[index] = el)}
                        onChange={(e) => {
                          
                          
                          props.onBroadcastSelectionChange(
                            datum,
                            e.target.checked
                          );
                        }}
                      />
                    </ListItemSecondaryAction>
                    <ListItemAvatar>
                      <Avatar
                        classes={{
                          img: classes.objectFit,
                        }}
                        src={datum?.mentorRequest?.mentorProfilePic}
                      />
                    </ListItemAvatar>
                    <ListItemText
                      primary={
                        <>
                          <Typography
                            style={{
                              fontFamily: "Montserrat",
                              fontSize: "16px",
                            }}
                          >
                            {datum?.mentorRequest?.mentorName}
                          </Typography>
                        </>
                      }
                    />
                  </ListItem>
                  <Divider variant="inset" component="li" />
                </>
              ))}
            </List>
          </Box>
          <Box
            style={{
              display: "flex",
              justifyContent: "space-around",
              padding: "25px 0",
              width: "100%",
            }}
          >
            <TextInput {...props} />
          </Box>
        </Paper>
      </Modal.Body>
    </Modal>
  );
};
const mapStateToProps = (state) => {
  return {
    getPredefineOptions: state.AdminMentorReducer.getPredefineOptionsList.list,
  };
};
export default connect(mapStateToProps, {
  getPredefineOptionsList,
  openLoader,
  closeLoader,
})(withRouter(CustomModal));
